import { createFileRoute } from '@tanstack/react-router';
import { BillingSettingsPage } from '../../components/settings/billing-settings-page.js';

export const Route = createFileRoute('/settings/billing')({
  component: BillingSettingsPage,
});
